import { matchPath } from 'react-router-dom';

import { DEMO_ALLOWED_ROUTES } from '@/constants/route';

const isRouteAllowedInDemo = (pathname: string): boolean =>
  DEMO_ALLOWED_ROUTES.some((pattern) => matchPath(pattern, pathname) !== null);

export { isRouteAllowedInDemo };
